import React, { useEffect, useState, useRef, useCallback } from "react";
import "./Distributor.css";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStyleWiseStockReport, getWise_Stock_Report } from "../../redux/actions/wiseStockReport.action";
import { getProductType } from "../../redux/actions/productType.action";
import { ReadCookie } from "../../utils/readCookie";
import { Spin, Select, DatePicker, Checkbox, Form, Input } from "antd";
import { getStyle } from "../../redux/actions/style";
import { getGenderCategory } from "../../redux/actions/genderCategory.action";
import { getNewSeason } from "../../redux/actions/newSeason.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getAdminLocation } from "../../redux/actions/adminLocation.action";
import moment from "moment";
import { CSVLink, CSVDownload } from "react-csv";
import { useDownloadExcel } from "react-export-table-to-excel";
import numeral, { Numeral } from "numeral";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import Loader from "react-spinners/BarLoader";
import { TabTitle } from "../../utils/GeneralFunction";
import { getDropshipFeedReport } from "../../redux/actions/dropshipfeed.action";
import { loadCustomers } from "../../redux/actions/customerForm";

const dateFormatList = ["MM-DD-YYYY"];

const DropshipFeed = ({ token }) => {
  TabTitle("Dropship Feed")
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    season,
    getWiseStockReport,
    productType,
    gender,
    productStatus,
    adminLocation,
    getNewSeasonReducer,
    customerForms
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const [BGradechecked, setBGradeChecked] = useState(false);
  const [pendingDate, setpendingDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);
  const [isChecked, setIsChecked] = useState([]);
  const [allSesion, setAllSesion] = useState(true);
  const [steps, setSteps] = useState([]);
  const stepsArr = [1, 17, 18, 25, 106, 2, 29, 20, 21, 22, 28, 33, 108, 109];
  const [pendingChecked, setPendingChecked] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const [allStatus, setAllStatus] = useState(true);
  const [isChecked2, setIsChecked2] = useState([]);
  const [loadding, setLoadding] = useState(false);
  const [dropshipFeed, setDropshipFeed] = useState([]);
  const [customer, setCustomer] = useState("All");
  const initialDate = moment('2026-12-31')

  const [allCustomerStatus, setAllCustomerStatus] = useState(true);
  const [allFilters, setAllFilters] = useState([
    { id: 1516580, name: "Moda Operandi", selected: false },
    { id: 70550, name: "Nordstrom D2C", selected: false },
    { id: 1628656, name: "Nordstrom Marketplace", selected: false },
    { id: 85782, name: "Saks Dropship", selected: false },
    // { id: 1429711, name: "Saks Marketplace", selected: false },
    { id: 1625777, name: "Bloomingdales-Dropship", selected: false },
    { id: 1628081, name: "Anthropologie Dropship", selected: false },
    { id: 1634633, name: "Army & Air Force Exchange Service", selected: false },
    { id: 1634213, name: "Rent the Runway Marketplace", selected: false },
  ]);

  const tableRef = useRef(null);
  const buttonRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Dropship-Feed",
    sheet: "Dropship-Feed",
  });

  const statusCustomerSelectAll = (e) => {
    const checked = e.target.checked;

    const updatedFilters = allFilters.map(item => ({
      ...item,
      selected: false,
    }));

    setAllFilters(updatedFilters);
    setAllCustomerStatus(checked);
  };

  // const customSortOrder = [
  //   "BERGEN WS",
  //   "BERGEN ECOM",
  //   "In Transit",
  //   "PK Warehouse",
  //   "Production",
  //   "International",
  //   "NORD D2C",
  //   "Saks D2C",
  //   "Moda D2C",
  //   "Macys D2C",
  //   "Anthro D2C",
  //   "Neiman D2C",
  //   "NRHL D2C"
  // ];

  // adminLocation?.payload?.data?.sort((a, b) => {
  //   const indexA = customSortOrder.indexOf(a.location_name);
  //   const indexB = customSortOrder.indexOf(b.location_name);

  //   return indexA - indexB;
  // })

  // useEffect(() => {
  //   if (adminLocation?.payload?.data?.length > 0) {
  //     setSteps(
  //       adminLocation?.payload?.data
  //         .filter((val) => stepsArr.includes(val.location_id))
  //         .map((it) => ({ ...it, selected: true }))
  //     );
  //   }
  // }, [adminLocation]);






  // const stepschecked =
  //   steps && steps?.filter((it) => it.selected)?.map((it) => it.location_id);

  // const getStepData =
  //   adminLocation &&
  //   adminLocation?.payload?.data.filter((val) =>
  //     stepsArr.includes(val.location_id)
  //   );




  // const [stepsChecked, setStepChecked] = useState([]);

  const statusSelectAll = (e) => {
    setAllStatus(e.target.checked);
  };

  const isCheckboxChecked2 = (id, value) => {
    const filterCheckBox =
      productStatus &&
      productStatus?.payload?.data?.find((val) => val.product_status_id === id);
    const checkId = isChecked2?.includes(id);
    if (!checkId) {
      setIsChecked2((current) => [
        ...current,
        filterCheckBox?.product_status_id,
      ]);
    }
    if (!value) {
      const removeUnCheck = isChecked2?.filter(
        (item) => item !== filterCheckBox?.product_status_id
      );
      setIsChecked2(removeUnCheck);
    }
    setAllStatus(false);
  };

  useEffect(() => {
    if (allStatus) {
      setIsChecked2([]);
    }
  }, [allStatus]);

  useEffect(() => {
    if (isChecked2.length === 0) {
      setAllStatus(true);
    }
  }, [isChecked2]);


  let result =
    dropshipFeed &&
    dropshipFeed.reduce(function (r, a) {
      r[a.sku + a.inseam] =
        r[a.sku + a.inseam] || [];
      r[a.sku + a.inseam].push(a);
      return r;
    }, Object.create(null));

  const wiseStockReport = result && Object.values(result);

  let transformedNested = wiseStockReport.map(innerArray => {
    // Har inner array ko process karte hain
    return innerArray.flatMap(item => {
      const specialGroups = ["NORD FEED", "MODA FEED", "MACYS FEED", "ANTHRO FEED", "AAFES FEED", "TOTAL OTS"];

      if (specialGroups.includes(item.bulk_order_no)) {
        // First entry with empty quantities
        let emptyQty = { ...item };
        emptyQty.total_qty = "";
        emptyQty.bulk_order_no = "";
        for (let i = 1; i <= 16; i++) {
          emptyQty[`qty_${i}`] = "";
        }
        // Return both empty and original quantities
        return [emptyQty, { ...item }];
      } else {
        return [{ ...item }];
      }
    });
  });




  const { Option } = Select;


  const onFinish = async (e) => {
    await form.validateFields().then((values) => {
      values.isChecked2 = isChecked2;
      let report = allFilters
        .filter((item) => item.selected === true)
        .map((item) => item.id);
      values.report = report.length > 0 ? report : [];
      const distributorParam = {
        sku: values.sku ? values.sku : null,
        gender_id: values.gender === "All" ? null : values.gender,
        style_id: values.style === "All" ? null : values.style,
        customer_id: report && report.length > 0 ? report.toString() : null,
        product_status_id: isChecked2.length > 0 ? isChecked2.toString() : null,
      };
      setLoading(true);
      dispatch(getDropshipFeedReport(token, distributorParam)).then((res) => {
        setLoading(false);
        setDropshipFeed(res?.payload?.data);
        downloadExcelFileData(res?.payload?.data);
      });
    });
  };


  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "SKU": v.sku,
          "Inseam": v.inseam,
          "Style": v.style_name,
          "Wash": v.wash_name,
          "Location": v.bulk_order_no,
          " 23 ": v.qty_1,
          " 24 ": v.qty_2,
          " 25 ": v.qty_3,
          " 26 ": v.qty_4,
          " 27 ": v.qty_5,
          " 28 ": v.qty_6,
          " 29 ": v.qty_7,
          " 30 ": v.qty_8,
          " 31 ": v.qty_9,
          " 32 ": v.qty_10,
          " 33 ": v.qty_11,
          " 34 ": v.qty_12,
          " 35 ": v.qty_13,
          " 36 ": v.qty_14,
          " 37 ": v.qty_15,
          " 38 ": v.qty_16,
          "Quantity": v.total_qty,
        };
      })
    );

  }

  useEffect(() => {
    dispatch(getStyle(token, menuId));
    // dispatch(getProductType(token, menuId));
    // dispatch(getSeason(token, menuId));
    // dispatch(getGenderCategory(token, menuId));
    dispatch(getGender(token, menuId));
    // dispatch(getNewSeason(token, menuId));
    dispatch(getProductStatus(token, menuId));
    // dispatch(getAdminLocation(token, menuId));
  }, [dispatch, menuId, token]);

  useEffect(() => {
    if (allSesion) {
      setIsChecked([]);
    }
  }, [allSesion]);

  useEffect(() => {
    if (allStatus) {
      setIsChecked2([]);
    }
  }, [allStatus]);

  const handlePrint = () => {
    window.print();
  };


  const isRestrictedSize = (gender, size) => {
    return (
      (gender === "Men" && size === "28") ||
      (gender === "Women" && (size === "23" || size === "23P")) ||
      size === "XS" ||
      (gender === "Kids" && (size === "7" || size === "8" || size === "S"))
    );
  };


  const getQtyValueByKeyForOTS = (data, qtyKey) => {
    const size = data?.firstsize;
    const gender = data?.gender_name;

    let suffix = parseInt(qtyKey.split("_")[1]); // qty_3 -> 3

    // Special shift logic
    if (size === "7") {
      if (suffix === 8) return 0; // <-- 7X index fixed as 0
      if (suffix > 8) suffix = suffix - 1; // shift remaining sizes
      suffix = suffix - 6;
    } else if (size === "8") {
      // suffix = suffix - 7; //previous condition valid for without 7X size
      suffix = suffix - 8;
    } else if (size === "S") {
      suffix = suffix - 2;
    }

    // Restricted logic
    const isRestricted = isRestrictedSize(gender, size);
    if (!["7", "8", "S"].includes(size) && isRestricted) {
      if (suffix === 1) return 0;
      suffix = suffix - 1;
    }

    const baseQtyKey = `qty_${suffix}`;
    const baseQty = Number(data?.[baseQtyKey]) || 0;

    return baseQty; // ← filters removed
  };




  return (
    <div className="distributor header_class stock_style_wise" style={{ width: "1270px" }}>
      <div className="row justify-content-between distributr">
        {/**** / Logo *****/}
        <div className="col-3 d-flex align-items-sm-center box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        <div className="col-3 box-space right-content-header text-sm-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8 printing_class">
              <div className="print_icon printing_class">
                <i
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  onClick={handlePrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div
                className="print_icon printing_class"
                name="ImgExcel"
                alt="Export to excel"
                id="ImgExcel"
                title="Export to excel"
                src={xlsx}
              >
                {/* <i className="fa-solid fa-file-excel"></i> */}

                {wiseStockReport ? (
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    onClick={onDownload}
                    style={{
                      borderWidth: "0px",
                      height: "14px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    style={{ borderWidth: "0px", height: "14px" }}
                  />
                )}
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Dropship Feed
              <br />
              Rpt # 489
              <br />
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
              {/* type="image"
              name="ImgExcel"
              alt="Export to excel"
              id="ImgExcel"
              title="Export to excel"
              src={xlsx}
              style={{ borderWidth: "0px", height: "20px" }}
            />  */}
            </span>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="business_class_oms distributr">
        {/* Table Selects */}
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className=" col-12 ">
              <hr className="my-1" />
              <div>
                <label htmlFor="">Product Status</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox checked={allStatus} onChange={statusSelectAll}>
                        All
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {productStatus &&
                    productStatus?.payload?.data.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="current_status_id">
                            <Checkbox
                              checked={
                                allStatus
                                  ? false
                                  : isChecked2.includes(it.product_status_id)
                              }
                              onChange={(e) =>
                                isCheckboxChecked2(
                                  it.product_status_id,
                                  e.target.checked
                                )
                              }
                            >
                              {it.product_status_name}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })}
                </div>
              </div>
              <hr className="my-1" />
              <div
              // className="row"
              >
                <label htmlFor="" style={{ marginRight: "25px" }}>Customer</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Form.Item name="customer_id" className=" mb-0">
                      <Checkbox
                        checked={allCustomerStatus} onChange={statusCustomerSelectAll}
                      >
                        All
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {allFilters &&
                    allFilters.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="customer_id">
                            <Checkbox
                              checked={it.selected}


                              onChange={(e) => {
                                const checked = e.target.checked;

                                // copy array
                                let copyArr = [...allFilters];

                                // update selected
                                copyArr[index] = {
                                  ...copyArr[index],
                                  selected: checked,
                                };

                                setAllFilters(copyArr);

                                // agar koi bhi checkbox selected hai
                                const isAnySelected = copyArr.some(item => item.selected);

                                // sab uncheck ho gaye → All true
                                setAllCustomerStatus(!isAnySelected);
                              }}
                            >
                              {it.name}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })}
                </div>
              </div>
              <hr className="my-1" />
              <div className="main_form row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Gender</label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="gender">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          <Option value="All">All</Option>
                          {gender &&
                            gender?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.gender_id}>
                                  {it.gender_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>

                </div>
                {/* Third */}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Style</label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="style">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_id}>
                                  {style.style_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/* Fourth */}
                {/* <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label htmlFor="" className="labels width30">Customer</label>
                    <div style={{ marginBottom: "5px" }} className=" w-100 fit-selectbox-width">
                      <Form.Item name="customer" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          <Option value="1429711">Saks Fifth Avenue Marketplace</Option>
                          <Option value="1516580">Moda Operandi, Inc. - Marketplace</Option>
                          <Option value="1625777">Bloomingdales-Dropship</Option>
                          <Option value="1628081">Urban Outfitters-Dropship</Option>
                          <Option value="70550">Nordstrom D2C</Option>
                          <Option value="1628656">Nordstrom Marketplace</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div> */}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Sku</label>
                    <div className="w-100">
                      <Form.Item name="sku" className="sku_input">
                        <Input size="small" className={"select_Inputs mb-0"} />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <div
                      style={{
                        marginTop: "4px",
                        display: "flex",
                        alignItems: "flex-start",
                        // justifyContent: 'flex-end'
                      }}
                    >
                      {!loading ?
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="submit-btn-btm m-0"
                        >
                          Generate
                        </Button> : <Spin size="medium" />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
        {/* <div
          style={{
            display: "none",
          }}
        >
          <CSVLink
            className="submit-btn-btm m-0"
            ref={buttonRef}
            filename={"Stock-Style-Wise.csv"}
            data={excelData}
          >
            Download Excel
          </CSVLink>
        </div>
        <Button
          type="primary"
          className="submit-btn-btm m-0"
          onClick={() => downLoadExcel(form.getFieldValue())}
        >
          {!loadding ? "Generate Excel" : <Loader className="spinner" />}
        </Button> */}
        { }
        {/* {excelData?.length > 0 ? (
          <div className="loader" style={{ marginTop: "20px" }}>
            <Spin size="medium" />
          </div>
        ) : null} */}
      </div>
      {/* Table  Data */}

      <div className="business_class_oms " ref={tableRef}>
        {wiseStockReport ? (
          wiseStockReport.length > 0 ? (
            transformedNested.map((data, index) => {
              const sizes = data;

              return (
                <div key={index}>
                  <div className="table_data-Heading distributr">
                    {data[0].sku} - {data[0].inseam}
                  </div>
                  <table className="table_distributor-data distributr">
                    <tbody>
                      <tr style={{ lineHeight: "32px", backgroundColor: "#e0e6ed" }}>
                        <td className="font-weig">#</td>
                        <td
                          style={{ width: "60px", fontWeight: "800" }}
                          className="font-weig"
                        >
                          SKU
                        </td>
                        <td className="font-weig">Inseam</td>
                        <td className="font-weig">Style</td>
                        <td className="font-weig">Wash</td>
                        <td className="font-weig">Location</td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_1}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_2}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_3}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_4}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_5}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_6}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_7}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_8}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_9}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_10}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_11}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_12}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_13}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_14}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_15}
                        </td>
                        <td style={{ width: "30px", textAlign: "right" }} className="font-weig">
                          {sizes[0].size_16}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right" }} >Quantity</td>
                      </tr>
                      {data.map((values, index) => {

                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{values.sku}</td>
                            <td>{values.inseam}</td>
                            <td>{values.style_name}</td>
                            <td>{values.wash_name}</td>
                            <td>{values.bulk_order_no}</td>

                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_1") : values.qty_1}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_2") : values.qty_2}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_3") : values.qty_3}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_4") : values.qty_4}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_5") : values.qty_5}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_6") : values.qty_6}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_7") : values.qty_7}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_8") : values.qty_8}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_9") : values.qty_9}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_10") : values.qty_10}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_11") : values.qty_11}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_12") : values.qty_12}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_13") : values.qty_13}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_14") : values.qty_14}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_15") : values.qty_15}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>
                              {values.bulk_order_no === "IMMEDIATE OTS" ? getQtyValueByKeyForOTS(values, "qty_16") : values.qty_16}
                            </td>
                            <td style={{ textAlign: "right", paddingRight: "2px" }}>{values.total_qty}</td>
                          </tr>
                        );
                      })}

                      {/* <tr>
                        <td className="font-weig"></td>
                        <td className="font-weig"></td>
                        <td className="font-weig"></td>
                        <td className="font-weig"></td>
                        <td className="font-weig"></td>
                        <td className="font-weig">Total</td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty1 !== qty1 ? "" : qty1}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty2 !== qty2 ? "" : qty2}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty3 !== qty3 ? "" : qty3}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty4 !== qty4 ? "" : qty4}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty5 !== qty5 ? "" : qty5}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty6 !== qty6 ? "" : qty6}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty7 !== qty7 ? "" : qty7}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty8 !== qty8 ? "" : qty8}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty9 !== qty9 ? "" : qty9}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty10 !== qty10 ? "" : qty10}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty11 !== qty11 ? "" : qty11}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty12 !== qty12 ? "" : qty12}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty13 !== qty13 ? "" : qty13}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty14 !== qty14 ? "" : qty14}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty15 !== qty15 ? "" : qty15}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>
                          {qty16 !== qty16 ? "" : qty16}
                        </td>
                        <td className="font-weig" style={{ textAlign: "right", paddingRight: "2px" }}>{numeral(sumQ).format("0,00,0")}</td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
              );
            })
          ) : (
            <div className="no-Data">
              <h1>No Data</h1>
            </div>
          )
        ) : (
          loading && (
            <div className="loader" style={{ marginTop: "20px" }}>
              <Spin size="medium" />
            </div>
          )
        )}
        { }
      </div>
    </div>
  );
};

export default DropshipFeed;